import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrganizationBuildingsWithTagsComponent from './components/OrganizationBuildingsWithTagsComponent/OrganizationBuildingsWithTagsComponent';
import OrganizationMapAndInfo from './components/OrganizationMapAndInfo/OrganizationMapAndInfo';
import { OrganizationAnomaliesAndProjects } from './components/OrganizationAnomaliesAndProjects';
import { OrganizationEnergyOverview } from './components/OrganizationEnergyOverview';
import { QuerySearchProvider } from './tables/OrganizationAnomaliesTable/hook/useQuerySearch';
import { useFeatureFlag } from 'context/FeatureFlagProvider/FeatureFlagProvider';
import { FEATURE_FLAGS_LIST } from 'lib/featureFlagsList';
import { useAuth } from 'hooks/contexts/AuthContext';

const OrganizationViewPage: FC = () => {
  const { t } = useTranslation();
  const { hasFeatureFlagPermission } = useFeatureFlag();
  const { user } = useAuth();
  const [companyName, setCompanyName] = useState(t('organizationView.title'));
  // User company name
  useEffect(() => {
    if (user?.company_name) {
      setCompanyName(user.company_name);
    }
  }, [user]);

  return (
    <div className="flex flex-col gap-4">
      <div className="mb-8">
        <h1 className="mb-2">
          {companyName} {t('organizationView.headers.hero.title')}
        </h1>
        <h3 className="text-base">
          {t('organizationView.headers.hero.subTitle')}
        </h3>
      </div>

      <OrganizationMapAndInfo />
      <QuerySearchProvider>
        <OrganizationBuildingsWithTagsComponent />
        <OrganizationAnomaliesAndProjects />
      </QuerySearchProvider>

      {hasFeatureFlagPermission(
        FEATURE_FLAGS_LIST.organizationSummary.get_sankey
      ) && <OrganizationEnergyOverview />}
    </div>
  );
};
export default OrganizationViewPage;
